<template>
  <traffic-count-component />
</template>

<script>
import TrafficCountComponent from "@/components/traffic-count/traffic-count";

export default {
  components: {
    TrafficCountComponent
  }
};
</script>

<style></style>
